import { request } from '@/shared/api/request'

export const remove = (payload) => {
	return request({ url: 'occupationalRisks/sendDeletionData', method: 'DELETE', data: payload })
}

export const removeOccupationalRisks = (data) => request({ method: 'DELETE', url: 'occupationalRisks/delete', data })
